import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Button } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { changeFormatdate } from '../../../utils/formatdate'
import { convertToHTMl } from '../../../utils/markDown'
import { youtubeParser } from '../../../utils/youtube'

const { Text, Title } = Typography

class Orientation extends React.Component {

    state = {
        detailPolicy: [],
        visibleModal: false,

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false
    }

    fetchListPostType = async () => {
        const { client, location } = this.props
        const { selectMonth, selectYear } = this.state
        // console.log("location.state.fetchKey", location.state.fetchKey);

        const { data, errors } = await client.query({
            query: Queries.fetchListPostType,
            variables: {
                type: "ORIENTATION",
            }
        })

        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            detailPolicy: data.fetchListPost.data[0],
        })
    }

    async componentDidMount() {
        await this.fetchListPostType()
    }


    render() {
        const { match, location } = this.props
        const { detailPolicy } = this.state

        return (
            <Container match={match} >
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-policy-hr">
                    <Row gutter={20}>
                        {
                            detailPolicy&&
                            <Col>
                                <div className="uiMediahead">
                                    <i className="uiMediaThumbImg" style={{ backgroundImage: "url(" + detailPolicy.bannerLink + ")", }}></i>
                                </div>
                                <div className="mt-4">
                                    <Title level={4}>
                                        {detailPolicy.postTitleTH}
                                    </Title>
                                    <Text>
                                        {detailPolicy.subTitleTH}
                                    </Text><br /><br />
                                    <Text>
                                        {detailPolicy.descriptionTH ? <div dangerouslySetInnerHTML={{ __html: convertToHTMl(detailPolicy.descriptionTH) }} /> : ''}
                                    </Text><br /><br />
                                    {
                                        detailPolicy.linkOriginal&&
                                        <Row gutter={20} className="mb-5">
                                            <Col span={18} offset={3} >
                                                {/* <img src={imgYoutube} style={{ maxWidth: "100%" }} /> */}
                                                <iframe src={"https://www.youtube.com/embed/"+youtubeParser(detailPolicy.linkOriginal)} style={{ width: '100%', height: '450px' }}></iframe>
                                            </Col>
                                        </Row>
                                    }

                                </div>
                            </Col>
                        }
                    </Row>
                </div>
            </Container>
        )
    }
}

Orientation.propTypes = {
    //
}

export default withApollo(Orientation)